import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Helmet } from '@games/ui';
import messages from 'intl/messages';
import { IS_DEV, AD_TEST } from 'config';
import classNames from 'classnames';

interface MyAdProps {
  slot: string;
  className?: string;
}

declare global {
  interface Window {
    adsbygoogle?: any[];
  }
}

const MyAd: React.FC<MyAdProps> = ({
  slot,
  className = '',
}) => {
  React.useEffect(() => {
    if(window && (!IS_DEV || AD_TEST)) {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    }
  }, []);

  return (
    <div className='my-4'>
      <Helmet>
        <script
          async
          src='//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js'
        />
      </Helmet>
      <div>
        <FormattedMessage {...messages.ad} />
      </div>
      <div className={classNames('ads-container', className)}>
        <ins
          className='adsbygoogle block'
          data-ad-client='ca-pub-1532657361966464'
          data-ad-slot={slot}
          data-ad-format='auto'
          data-adtest={IS_DEV && AD_TEST && 'on'}
          data-full-width-responsive='true'
        />
      </div>
    </div>
  );
};

export default MyAd;
